import { executePredicatedProcessors } from '../../lib/predicatedProcessor';
import { createChangeProcessors } from './changeProcessors';
import type { Change, ChangelogInputBundle, ProcessingBuffer } from '../../types';
import type createTemplates from './templates';

export default function format(args: {
  changes: Change[];
  processingBuffer: ProcessingBuffer;
  templates: ReturnType<typeof createTemplates>;
  A: ChangelogInputBundle;
  B: ChangelogInputBundle;
}) {
  const {
    A,
    B,
    changes,
    processingBuffer,
    templates,
  } = args;

  const changeProcessors = createChangeProcessors({
    A,
    B,
    entriesBuffer: processingBuffer,
    templates,
  });

  executePredicatedProcessors({
    items: changes,
    processorRegistry: changeProcessors,
  });

  return processingBuffer.package();
}
